import styled from 'styled-components';
import { Icon } from './Icon';
import { Variant } from '../../common/variant';

export const CircularIcon = styled(Icon)`
  stroke-width: 0.156rem;
  color: ${({ variant = Variant.Info, theme }) => theme.colours.circularIcon[variant].text};
  background-color: ${({ variant = Variant.Info, theme }) => theme.colours.circularIcon[variant].background};
`;
